import React from 'react';
import Overview from 'views/Meteorology/Agro/Overview';

const overviewRouter = {
  path: 'overview',
  element: <Overview />,
};

export default overviewRouter;
